import { TextField, InputAdornment, withStyles } from "@material-ui/core";
import PropTypes from "prop-types";
import { formatNumberToMonetary } from "../../../utils";
import { lang } from "../../../i18nLang";

interface IProps {
  [property: string]: any;
  /** Valor do campo. Deve ser um valor númerico válido, pois este será formatado com a máscara "#0,00" para ser exibido no input. */
  value: number;
  /** O campo sempre está definido como ReadOnly, porém, é possível habilitar/desabilitar a cor (fundo cinza) para readonly com esta propriedade. */
  readonlyColor: boolean;
  /** Margin personalizada do campo, que pode ser passada como um único valor, um array com dois valores ou um array com quatro valores.
   * Só serão aceitos valores númericos que serão multiplicados por 0.25rem.  */
  margin: number | number[];
}

/**
 * ##### Campo para exibir valores totalizados.
 * @category Components
 * */
const MonetaryField = withStyles((theme) => ({
  root: {
    justifyContent: "center",
    "& .MuiInputBase-root": {
      maxWidth: 160,
      "& > .MuiInputBase-input": { textAlign: "right" },
      "& > .MuiInputAdornment-root > p": {
        fontWeight: 700,
        color: theme.palette.gray[800],
      },
      "&.Mui-focused > .MuiOutlinedInput-notchedOutline": {
        borderColor: "#000",
        borderWidth: 1,
      },
    },
    "& > .MuiInputLabel-root": {
      color: "#727272 !important",
      textTransform: "initial",
      letterSpacing: 0,
    },
    "&.readonly-color .MuiInputBase-root": {
      backgroundColor: "#EEEEEE",
      "& > .MuiOutlinedInput-notchedOutline": {
        border: "1px solid #ABAAAC",
      },
    },
  },
}))(({ value, readonlyColor, margin, style, ...otherProps }: IProps) => {
  let newStyle = {
    ...style,
    margin: Array.isArray(margin)
      ? margin
          .slice(0, 4)
          .map((val) => `${val}rem`)
          .join(" ")
      : `${margin}rem`,
  };

  return (
    <TextField
      {...otherProps}
      className={readonlyColor ? "readonly-color" : ""}
      value={formatNumberToMonetary(value, false)}
      variant="outlined"
      type="text"
      style={newStyle}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">{lang("currency")}</InputAdornment>
        ),
        readOnly: true,
      }}
    />
  );
});

MonetaryField.propTypes = {
  value: PropTypes.number,
  readonlyColor: PropTypes.bool,
  margin: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.arrayOf(PropTypes.number),
  ]),
};

MonetaryField.defaultProps = {
  margin: [0, 0.5],
};

export default MonetaryField;
